import type { TypePageBuilderSkeleton } from '~/types/contentful'

// V2 profile page entry; its `config.testDataStoreIds` is the shared allowlist.
const V2_PROFILE_ENTRY_ID = '4cCCfJm6miGG3mD2yVC5cs'

// Reads the mock-store allowlist off the profile page entry. Locale-independent
// (default-locale config, no locale key/watch) so a language switch can't blank
// it and drop the mock overlay, leaving graphs empty.
export async function useTestDataStoreIds() {
  const { $client } = useNuxtApp()

  const { data } = await useAsyncData('test-data-store-ids', async () => {
    try {
      const response =
        await $client.withoutUnresolvableLinks.getEntries<TypePageBuilderSkeleton>(
          {
            content_type: 'pageBuilder',
            'sys.id': V2_PROFILE_ENTRY_ID,
            limit: 1,
            select: ['fields.config'],
          },
        )
      const config = (response?.items?.[0]?.fields?.config || {}) as {
        testDataStoreIds?: string[]
      }
      return config.testDataStoreIds ?? []
    } catch (e) {
      console.log('Error retrieving test data store IDs.', e)
      return [] as string[]
    }
  })

  return computed(() => data.value ?? [])
}
